import type { TrainingLessonCanonicalContent } from './trainingLessonContent.types';

export const core1RestoreEn: TrainingLessonCanonicalContent = {
  intro:
    'The Restoration of the gospel of Jesus Christ is the most important event since the Savior’s resurrection. In this lesson you will explore its foundations and how to apply them in your life.',
  objectivesHeading: 'Objectives',
  objectives: [
    'Understand what the Restoration of the gospel means',
    'Identify key events of the Restoration',
    'Recognize the role of the Book of Mormon as evidence',
    'Reflect on how the Restoration impacts your life',
  ],
  briefHeading: 'The Restoration in brief',
  briefBody:
    'After centuries of apostasy, Heavenly Father and Jesus Christ appeared to Joseph Smith in the spring of 1820. Through him, priesthood authority, ordinances, and additional scripture—including the Book of Mormon—were restored.',
  scripturesHeading: 'Key scriptures',
  scriptures: [
    {
      ref: 'Joseph Smith—History 1:17',
      text: 'I saw two Personages, whose brightness and glory defy all description...',
    },
    {
      ref: 'Doctrine and Covenants 1:30',
      text: 'And also those to whom these commandments were given, to go forth and lay the foundation of Zion',
    },
    {
      ref: 'Articles of Faith 1:6',
      text: 'We believe in the same organization that existed in the Primitive Church...',
    },
  ],
  didYouKnowHeading: 'Did you know…?',
  didYouKnow: [
    'The First Vision occurred when Joseph Smith was 14, in a grove near his home in Palmyra, New York.',
    'The Book of Mormon was published in 1830, ten years after the First Vision, as tangible evidence of the Restoration.',
  ],
  practiceHeading: 'Practice',
  practiceHint: 'Check off activities as you complete them (saved automatically)',
  practiceItems: [
    'Read Joseph Smith—History 1:1–20',
    'Ponder a question you would like to ask the Lord',
    'Share with someone what the Restoration means to you',
    'Review the introduction to the Book of Mormon',
  ],
  practiceDone: 'Completed',
  practicePending: 'Pending',
  reflectionHeading: 'Reflection questions',
  reflectionHint: 'Write your thoughts (saved automatically)',
  reflectionQuestions: [
    'Which aspect of the Restoration feels most meaningful to you right now?',
    'How does the Book of Mormon help you know the Restoration is true?',
    'What can you do this week to strengthen your testimony of the Restoration?',
  ],
  reflectionPlaceholder: 'Write here...',
  actionHeading: 'Action this week',
  actionText:
    'Share with a family member or friend an experience when you felt the restored gospel has blessed you.',
};
